export default {
  additional_questions: '',
  default_gender: 'male',
  tags: ['ללא_ניסיון', 'please add relevant here'],
  is_job_title_mandatory: true,
  auto_description: {
    show_certification_date: false
  }
}
